export default __webpack_public_path__ + "static/media/Icons_Heart_Outline.43e3b88f.svg";